// Current/Amperage alert distance data structured for dropdown usage: Sensitivity -> Amperage -> Record
// Source: lab test "Wire suspended 6 feet above ground" — first alert distances in ft.
// Max alert distances = 60% of first alert, rounded to 1 dp. Meters converted from ft (1 ft = 0.3048 m), rounded to 1 dp.

// we want to ignore the following eslint and prettier rules for the large data objects below
// prettier-ignore
const AMPERAGE_DATA = {
  displayName: 'Amperage',
  amperages: {
    '1A RMS': {
      displayName: '1A RMS',
      sensitivities: {
        1:  { sensitivity: 1,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        2:  { sensitivity: 2,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        3:  { sensitivity: 3,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        4:  { sensitivity: 4,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        5:  { sensitivity: 5,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        6:  { sensitivity: 6,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        7:  { sensitivity: 7,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        8:  { sensitivity: 8,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        9:  { sensitivity: 9,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        10: { sensitivity: 10, distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        11: { sensitivity: 11, distances: { first: { feet: 1,   meters: 0.3 }, max: { feet: 0.6, meters: 0.2 } } },
      },
    },
    '10A RMS': {
      displayName: '10A RMS',
      sensitivities: {
        1:  { sensitivity: 1,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        2:  { sensitivity: 2,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        3:  { sensitivity: 3,  distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
        4:  { sensitivity: 4,  distances: { first: { feet: 1,   meters: 0.3 }, max: { feet: 0.6, meters: 0.2 } } },
        5:  { sensitivity: 5,  distances: { first: { feet: 1.5, meters: 0.5 }, max: { feet: 0.9, meters: 0.3 } } },
        6:  { sensitivity: 6,  distances: { first: { feet: 1.5, meters: 0.5 }, max: { feet: 0.9, meters: 0.3 } } },
        7:  { sensitivity: 7,  distances: { first: { feet: 2,   meters: 0.6 }, max: { feet: 1.2, meters: 0.4 } } },
        8:  { sensitivity: 8,  distances: { first: { feet: 2.5, meters: 0.8 }, max: { feet: 1.5, meters: 0.5 } } },
        9:  { sensitivity: 9,  distances: { first: { feet: 2.5, meters: 0.8 }, max: { feet: 1.5, meters: 0.5 } } },
        10: { sensitivity: 10, distances: { first: { feet: 3,   meters: 0.9 }, max: { feet: 1.8, meters: 0.5 } } },
        11: { sensitivity: 11, distances: { first: { feet: 3.5, meters: 1.1 }, max: { feet: 2.1, meters: 0.6 } } },
      },
    },
    '50A RMS': {
      displayName: '50A RMS',
      sensitivities: {
        1:  { sensitivity: 1,  distances: { first: { feet: 2,   meters: 0.6 }, max: { feet: 1.2, meters: 0.4 } } },
        2:  { sensitivity: 2,  distances: { first: { feet: 2,   meters: 0.6 }, max: { feet: 1.2, meters: 0.4 } } },
        3:  { sensitivity: 3,  distances: { first: { feet: 2.5, meters: 0.8 }, max: { feet: 1.5, meters: 0.5 } } },
        4:  { sensitivity: 4,  distances: { first: { feet: 2.5, meters: 0.8 }, max: { feet: 1.5, meters: 0.5 } } },
        5:  { sensitivity: 5,  distances: { first: { feet: 3,   meters: 0.9 }, max: { feet: 1.8, meters: 0.5 } } },
        6:  { sensitivity: 6,  distances: { first: { feet: 3,   meters: 0.9 }, max: { feet: 1.8, meters: 0.5 } } },
        7:  { sensitivity: 7,  distances: { first: { feet: 3.5, meters: 1.1 }, max: { feet: 2.1, meters: 0.6 } } },
        8:  { sensitivity: 8,  distances: { first: { feet: 4,   meters: 1.2 }, max: { feet: 2.4, meters: 0.7 } } },
        9:  { sensitivity: 9,  distances: { first: { feet: 4.5, meters: 1.4 }, max: { feet: 2.7, meters: 0.8 } } },
        10: { sensitivity: 10, distances: { first: { feet: 5.5, meters: 1.7 }, max: { feet: 3.3, meters: 1.0 } } },
        11: { sensitivity: 11, distances: { first: { feet: 6.5, meters: 2.0 }, max: { feet: 3.9, meters: 1.2 } } },
      },
    },
    '100A RMS': {
      displayName: '100A RMS',
      sensitivities: {
        1:  { sensitivity: 1,  distances: { first: { feet: 2.5, meters: 0.8 }, max: { feet: 1.5, meters: 0.5 } } },
        2:  { sensitivity: 2,  distances: { first: { feet: 2.5, meters: 0.8 }, max: { feet: 1.5, meters: 0.5 } } },
        3:  { sensitivity: 3,  distances: { first: { feet: 3,   meters: 0.9 }, max: { feet: 1.8, meters: 0.5 } } },
        4:  { sensitivity: 4,  distances: { first: { feet: 3.5, meters: 1.1 }, max: { feet: 2.1, meters: 0.6 } } },
        5:  { sensitivity: 5,  distances: { first: { feet: 3.5, meters: 1.1 }, max: { feet: 2.1, meters: 0.6 } } },
        6:  { sensitivity: 6,  distances: { first: { feet: 4,   meters: 1.2 }, max: { feet: 2.4, meters: 0.7 } } },
        7:  { sensitivity: 7,  distances: { first: { feet: 5,   meters: 1.5 }, max: { feet: 3.0, meters: 0.9 } } },
        8:  { sensitivity: 8,  distances: { first: { feet: 5.5, meters: 1.7 }, max: { feet: 3.3, meters: 1.0 } } },
        9:  { sensitivity: 9,  distances: { first: { feet: 6.5, meters: 2.0 }, max: { feet: 3.9, meters: 1.2 } } },
        10: { sensitivity: 10, distances: { first: { feet: 8,   meters: 2.4 }, max: { feet: 4.8, meters: 1.5 } } },
        11: { sensitivity: 11, distances: { first: { feet: 8.5, meters: 2.6 }, max: { feet: 5.1, meters: 1.6 } } },
      },
    },
    '200A RMS': {
      displayName: '200A RMS',
      sensitivities: {
        1:  { sensitivity: 1,  distances: { first: { feet: 3.5, meters: 1.1 }, max: { feet: 2.1, meters: 0.6 } } },
        2:  { sensitivity: 2,  distances: { first: { feet: 4,   meters: 1.2 }, max: { feet: 2.4, meters: 0.7 } } },
        3:  { sensitivity: 3,  distances: { first: { feet: 4.5, meters: 1.4 }, max: { feet: 2.7, meters: 0.8 } } },
        4:  { sensitivity: 4,  distances: { first: { feet: 4.5, meters: 1.4 }, max: { feet: 2.7, meters: 0.8 } } },
        5:  { sensitivity: 5,  distances: { first: { feet: 5,   meters: 1.5 }, max: { feet: 3.0, meters: 0.9 } } },
        6:  { sensitivity: 6,  distances: { first: { feet: 5.5, meters: 1.7 }, max: { feet: 3.3, meters: 1.0 } } },
        7:  { sensitivity: 7,  distances: { first: { feet: 6,   meters: 1.8 }, max: { feet: 3.6, meters: 1.1 } } },
        8:  { sensitivity: 8,  distances: { first: { feet: 7,   meters: 2.1 }, max: { feet: 4.2, meters: 1.3 } } },
        9:  { sensitivity: 9,  distances: { first: { feet: 8,   meters: 2.4 }, max: { feet: 4.8, meters: 1.5 } } },
        10: { sensitivity: 10, distances: { first: { feet: 9.5, meters: 2.9 }, max: { feet: 5.7, meters: 1.7 } } },
        11: { sensitivity: 11, distances: { first: { feet: 11,  meters: 3.4 }, max: { feet: 6.6, meters: 2.0 } } },
      },
    },
    '600A RMS': {
      displayName: '600A RMS',
      sensitivities: {
        1:  { sensitivity: 1,  distances: { first: { feet: 5.5,  meters: 1.7 }, max: { feet: 3.3, meters: 1.0 } } },
        2:  { sensitivity: 2,  distances: { first: { feet: 6,    meters: 1.8 }, max: { feet: 3.6, meters: 1.1 } } },
        3:  { sensitivity: 3,  distances: { first: { feet: 6.5,  meters: 2.0 }, max: { feet: 3.9, meters: 1.2 } } },
        4:  { sensitivity: 4,  distances: { first: { feet: 7,    meters: 2.1 }, max: { feet: 4.2, meters: 1.3 } } },
        5:  { sensitivity: 5,  distances: { first: { feet: 7.5,  meters: 2.3 }, max: { feet: 4.5, meters: 1.4 } } },
        6:  { sensitivity: 6,  distances: { first: { feet: 8.5,  meters: 2.6 }, max: { feet: 5.1, meters: 1.6 } } },
        7:  { sensitivity: 7,  distances: { first: { feet: 9.5,  meters: 2.9 }, max: { feet: 5.7, meters: 1.7 } } },
        8:  { sensitivity: 8,  distances: { first: { feet: 11,   meters: 3.4 }, max: { feet: 6.6, meters: 2.0 } } },
        9:  { sensitivity: 9,  distances: { first: { feet: 12.5, meters: 3.8 }, max: { feet: 7.5, meters: 2.3 } } },
        10: { sensitivity: 10, distances: { first: { feet: 15,   meters: 4.6 }, max: { feet: 9.0, meters: 2.7 } } },
        11: { sensitivity: 11, distances: { first: { feet: undefined, meters: undefined }, max: { feet: undefined, meters: undefined } } },
      },
    },
  },
};

export interface CurrentDistanceData {
  feet: number | undefined;
  meters: number | undefined;
}

export interface CurrentSensitivityRecord {
  sensitivity: number;
  distances: {
    first: CurrentDistanceData;
    max: CurrentDistanceData;
  };
}

export interface CurrentType {
  displayName: string;
  sensitivities: Record<number, CurrentSensitivityRecord>;
}

export const CURRENT_DISTANCE_DATA: Record<string, CurrentType> =
  AMPERAGE_DATA.amperages;

// Helper function to get the first available current type for a given range and sensitivity
export const getFirstCurrentType = (
  _range: string,
  _sensitivity: number,
): string => {
  const currentTypes = Object.keys(CURRENT_DISTANCE_DATA);
  return currentTypes[0] || '';
};
